import { Component, Input } from '@angular/core';

@Component({
	selector    : 'user-avatar',
	templateUrl : 'user-avatar.html',
	styleUrls   : [ 'user-avatar.scss' ]
})

export class UserAvatarComponent {
	@Input() profilePhoto : string;
}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-dev/src/app/components/user-avatar/user-avatar.ts